import type {
	ListAlertsParams,
	PaginatedAlertsResponse,
	SystemAlert,
} from "src/types";
import apiRequest from "src/utils/api-request";
import withApiPath from "src/utils/with-api-path";

const alertProvider = {
	async listAlerts(
		params: ListAlertsParams = {},
	): Promise<PaginatedAlertsResponse> {
		const queryParams: Record<string, string | number> = {
			limit: params.limit ?? 20,
			offset: params.offset ?? 0,
		};

		if (params.status) {
			queryParams.status = params.status;
		}
		if (params.severity) {
			queryParams.severity = params.severity;
		}
		if (params.category) {
			queryParams.category = params.category;
		}

		const response = await apiRequest.get(withApiPath("/alerts"), {
			params: queryParams,
		});

		return response.data;
	},

	async getAlert(alertId: number | string): Promise<SystemAlert> {
		const response = await apiRequest.get(withApiPath(`/alerts/${alertId}`));
		return response.data;
	},

	async acknowledgeAlert(alertId: number | string): Promise<SystemAlert> {
		const response = await apiRequest.post(
			withApiPath(`/alerts/${alertId}/acknowledge`),
		);
		return response.data;
	},

	async resolveAlert(alertId: number | string): Promise<SystemAlert> {
		const response = await apiRequest.post(
			withApiPath(`/alerts/${alertId}/resolve`),
		);
		return response.data;
	},
};

export default alertProvider;
